import React from 'react';
import ViewLoadsPlanDetailsByDriver from './cards-panel/ViewLoadsPlanDetailsByDriver';
import ViewSummaryByDriver from './sidebar/ViewSummaryByDriver';

const LoadsPlan = () => {
  const cardsPanelProps = {};

  const sidebar = <ViewSummaryByDriver />;

  const cardsPanel = <ViewLoadsPlanDetailsByDriver {...cardsPanelProps} />;

  return (
    <>
      {sidebar}
      {cardsPanel}
    </>
  );
};

export default LoadsPlan;
